import { render, staticRenderFns } from "./MyShopCart.vue?vue&type=template&id=749e5fe2"
import script from "./MyShopCart.vue?vue&type=script&lang=js"
export * from "./MyShopCart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports